import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from './i18n/locale';
import { mergePageResources } from './i18n/pageResources';

import navbarEN from './locales/en/components/navbar.json';
import footerEN from './locales/en/components/footer.json';
import navbarDE from './locales/de/components/navbar.json';
import footerDE from './locales/de/components/footer.json';
import navbarRU from './locales/ru/components/navbar.json';
import footerRU from './locales/ru/components/footer.json';
import navbarNL from './locales/nl/components/navbar.json';
import footerNL from './locales/nl/components/footer.json';
import navbarZH from './locales/zh/components/navbar.json';
import footerZH from './locales/zh/components/footer.json';
import navbarFI from './locales/fi/components/navbar.json';
import footerFI from './locales/fi/components/footer.json';
import navbarIT from './locales/it/components/navbar.json';
import footerIT from './locales/it/components/footer.json';
import cookieModalEN from './locales/en/components/cookieModal.json';
import cookieModalDE from './locales/de/components/cookieModal.json';
import cookieModalRU from './locales/ru/components/cookieModal.json';
import cookieModalNL from './locales/nl/components/cookieModal.json';
import cookieModalZH from './locales/zh/components/cookieModal.json';
import cookieModalFI from './locales/fi/components/cookieModal.json';
import cookieModalIT from './locales/it/components/cookieModal.json';
import contactTicketFormEN from './locales/en/components/contactTicketForm.json';
import contactTicketFormDE from './locales/de/components/contactTicketForm.json';
import contactTicketFormRU from './locales/ru/components/contactTicketForm.json';
import contactTicketFormNL from './locales/nl/components/contactTicketForm.json';
import contactTicketFormZH from './locales/zh/components/contactTicketForm.json';
import contactTicketFormFI from './locales/fi/components/contactTicketForm.json';
import contactTicketFormIT from './locales/it/components/contactTicketForm.json';
import getInTuchEN from './locales/en/components/getInTuch.json';
import getInTuchDE from './locales/de/components/getInTuch.json';
import getInTuchRU from './locales/ru/components/getInTuch.json';
import getInTuchNL from './locales/nl/components/getInTuch.json';
import getInTuchZH from './locales/zh/components/getInTuch.json';
import getInTuchFI from './locales/fi/components/getInTuch.json';
import getInTuchIT from './locales/it/components/getInTuch.json';

const resources = mergePageResources({
    en: {
        navbar: navbarEN,
        footer: footerEN,
        cookieModal: cookieModalEN,
        contactTicketForm: contactTicketFormEN,
        getInTuch: getInTuchEN,
    },
    de: {
        navbar: navbarDE,
        footer: footerDE,
        cookieModal: cookieModalDE,
        contactTicketForm: contactTicketFormDE,
        getInTuch: getInTuchDE,
    },
    ru: {
        navbar: navbarRU,
        footer: footerRU,
        cookieModal: cookieModalRU,
        contactTicketForm: contactTicketFormRU,
        getInTuch: getInTuchRU,
    },
    nl: {
        navbar: navbarNL,
        footer: footerNL,
        cookieModal: cookieModalNL,
        contactTicketForm: contactTicketFormNL,
        getInTuch: getInTuchNL,
    },
    zh: {
        navbar: navbarZH,
        footer: footerZH,
        cookieModal: cookieModalZH,
        contactTicketForm: contactTicketFormZH,
        getInTuch: getInTuchZH,
    },
    fi: {
        navbar: navbarFI,
        footer: footerFI,
        cookieModal: cookieModalFI,
        contactTicketForm: contactTicketFormFI,
        getInTuch: getInTuchFI,
    },
    it: {
        navbar: navbarIT,
        footer: footerIT,
        cookieModal: cookieModalIT,
        contactTicketForm: contactTicketFormIT,
        getInTuch: getInTuchIT,
    },
});

i18n
    .use(initReactI18next)
    .init({
        resources,
        defaultNS: 'navbar',
        lng: DEFAULT_LOCALE,
        fallbackLng: DEFAULT_LOCALE,
        supportedLngs: SUPPORTED_LOCALES,
        debug: process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
